import { Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AccountsService } from 'src/app/common/services/accounts/accounts.service';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { InternalSettings, PermissionList } from 'src/app/common/services/internal-settings/internal-settings.interface';
import { InternalSettingsService, hasOnePermission } from 'src/app/common/services/internal-settings/internal-settings.service';
import { UserService } from 'src/app/common/services/user/user.service';
import { ModulesWithAvailableActivityList } from '../available-activities/available-activities.component';
import { NavigationService } from 'src/app/system/utility/navigation.service';
import { Router } from '@angular/router';
import { MultiCardType } from '../manage-multi-card/manage-multi-card.bean';

@Component({
    selector: 'app-services-card',
    templateUrl: './services-card.component.html',
    styleUrls: ['./services-card.component.less'],
    standalone: false
})
export class ServicesCardComponent implements OnInit {

  PermissionList : any = PermissionList;
  private externalSettings!: ExternalSettings;
  private internalSettings!: InternalSettings;

  protected MultiCardType: any = MultiCardType;

  public isReportLostCard!: boolean;
  public isChangeAddress!: boolean;
  public isManageCreditCard!: boolean;
  public isManageDebitCard!: boolean;
  public isManageMultiCreditCard!: boolean;
  public isManageMultiDebitCard!: boolean;

  constructor(
    private readonly router: Router,
    private readonly srvES: ExternalSettingsService,
    private readonly srvAccounts: AccountsService,
    private readonly srvIS: InternalSettingsService) { }

  ngOnInit(): void {
    combineLatest([
      this.srvES.externalSettings$,
      this.srvIS.internalSettings$,
      this.srvAccounts.getHiddenAccounts()
    ]).subscribe(([externalSettings, internalSettings, accounts]) => {

      if (!internalSettings) return;

      this.externalSettings = externalSettings;
      this.internalSettings = internalSettings;

      let hasMultiFiservCreditCard = AccountsService.getLoansAccounts(accounts).some(AccountsService.isFiservLoan);

      const globalVariables = this.externalSettings.globalVariables;
      const permissions = this.internalSettings.permissions;
      this.isChangeAddress = hasOnePermission([PermissionList.SERVICE_CREATE_CHANGE_ADDRESS], permissions);
      this.isReportLostCard = hasOnePermission([PermissionList.SERVICE_REPORT_LOST_CREATE], permissions);
      this.isManageCreditCard = false; // globalVariables.isModuleEnabledCreditCard    * Always hide to align with mobile
      this.isManageDebitCard = hasOnePermission([PermissionList.ACCESS_ACCOUNT_LISTING], permissions) && (globalVariables.isModuleEnabledDebitCardsI2C || globalVariables.isModuleEnabledDebitCard);
      this.isManageMultiCreditCard = hasOnePermission([PermissionList.MOBILEARTH_ACCESS_CUSTOMER_ACCESS_CREDIT_CARDS_LIST], permissions) && globalVariables.isModuleEnabledCreditCardService && hasMultiFiservCreditCard;
      this.isManageMultiDebitCard = hasOnePermission([PermissionList.MOBILEARTH_ACCESS_CUSTOMER_ACCESS_DEBIT_CARDS_LIST], permissions) && globalVariables.isModuleEnabledDebitCardService;
    });
  }

  protected onBackClick() {
    return NavigationService.gotoActivityPage(this.router, ModulesWithAvailableActivityList.SERVICES);
  }
}

/**
 * For Mobile Responsive / Mobile App
 */
export function isCardMenuAvailable(internalSettings: InternalSettings, externalSettings: ExternalSettings) : boolean { 

  // Corporate Agent do not show the menu
  if (UserService.isCorporateAgent(internalSettings, externalSettings)) return false;

  let permissions = internalSettings.permissions;
  let globalVariables = externalSettings.globalVariables;

  // Manage Debit Card  
  if (hasOnePermission([PermissionList.ACCESS_ACCOUNT_LISTING], permissions) && (globalVariables.isModuleEnabledDebitCardsI2C || globalVariables.isModuleEnabledDebitCard)) return true;

  // Manage Credit Card
  // if (globalVariables.isModuleEnabledCreditCard) return true;

  // Change Address
  if (hasOnePermission([PermissionList.SERVICE_CREATE_CHANGE_ADDRESS], permissions)) return true;

  // Report Lost
  if (hasOnePermission([PermissionList.SERVICE_REPORT_LOST_CREATE], permissions)) return true;

  // Manage Multi Credit Card
  if (hasOnePermission([PermissionList.MOBILEARTH_ACCESS_CUSTOMER_ACCESS_CREDIT_CARDS_LIST], permissions) && globalVariables.isModuleEnabledCreditCardService) return true;

  // Manage Multi Debit Card, please note that there is an issue that we are not able to determine whether customer have FISERVE ard or not
  if (hasOnePermission([PermissionList.MOBILEARTH_ACCESS_CUSTOMER_ACCESS_DEBIT_CARDS_LIST], permissions) && globalVariables.isModuleEnabledDebitCardService) return true;

  return false;

}